import { Injectable } from '@angular/core';
import config from './config';
import { Router } from '@angular/router';
import { UserdataService } from './userdata.service';
import {config as AppConfig} from 'config';

import { environment } from 'environments/environment';
import { HelperService } from './helper.service';
import { EbookHelperService } from './ebook-helper.service';
declare var $:any;
import { Subject } from 'rxjs';
import { DesktopEBookVMService } from './desktop-ebook-vm.service';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { ActivateComponentService } from './activate-component.service';
import { DesktopAppEventsService } from 'modules/app/services/desktop-app-events-service';

@Injectable()
export class DownloadHelperService {

    downloadingList = null;
    downloadedList = null;
    pausedList = null;

    peDownloadingList = null;
    peDownloadedList = null;
    pePausedList = null;

    downloadDetailsDefault = {
        progress: 0,
        location: '',
        totalPackageSize: 0,
        downloadedPackageSize: 0,
        downloadUnit: '--',
        error: null,
        wait: false,
        usersWithAccess: [],
        downloadedPackageUnzippedSize: 0,
        downloadedPackageUnzippedUnit: '--',
        unZippedPackagedSize: 0,
        unZippedPackagedUnit: '--',
        autoUpdateStatus: {}
    };
    broadcastChannel = null;
    progressIntervalFunction = null;
    availableDiskSpace = null;    
    availableDiskBufferSpace = 52428800;

    pplusBookcodes = [];
    bookForDownloadError: string;
    private downloadChangeNotifier = new Subject<any>();
    downloadChangeNotifierObservable$ = this.downloadChangeNotifier.asObservable();

    private removeDownloadNotifier = new Subject<any>();
    removeDownloadNotifierObservable$ = this.removeDownloadNotifier.asObservable();

    /**
     * used to store the downloading info for the book.
     * 'bookCode' : {
     *      'eventInProgress' : "true | false",
     *      'currentEvent' : 'start | pause'
     *      'eventArray' : [],
     *      'product' : 'product object with manifest'
     *      'removeData' : {product : {product, manifest}, productCode } user data required to remove a downloaded book.
     *      'resolver' : '{resolver : remove promise's resolver}' 
     * }
     */
    ebookDownloadMap = {};
    /**
     * used to manage the button state in UI
     * sample structure
     * stateMap = {
     *  'ebookCode' : 'last UI state'
     * }
     */
    ebookDownloadStateMap = {};
    bookToLinkedPEProgressMap = {};

    ebookToPEMap = {};
    PEtoEBookMap = {};

    productToDownloadedVersionMap = {};

    autoUpdateStatus = {};
    autoUpdateInProgress = false;
    autoUpdateQueue = [];
    bookToUsersWithAccessMap = {};

    // any change here should also be made in the reset function.
    // increase limit of max parallel downloads for current REL deployment.
    downloadQueueConfig = {
        maxParallelDownloadsAllowed: 3,
        currentParallelDownloads: 0,
        productDownloadQueue: [],
        currentlyDownloadingProductCodes: [],
        currentlyQueuedProductCodes: []
    }

    EVENTS = {
        PAUSE: "PAUSE",
        START: "START",
        REMOVE: "REMOVE",
        FINISH: "FINISH"
    }
    
    bookIDtoSpaceIDmap = new Map();
    isOnline: boolean = false;

    public pplusBundleCodeToPPlusProductMap = {};
    public pPlusBookCodeToBundleCodeMap = {};
    public pplusBundleCodetoBookCodeMap = {};
    public pplusBundleBookDownloadStateMap = {};
    public pplusBundleDownloadStateMap = {};
    public pplusBundleUserActionStateMap = {};

    constructor(
        private userdataService: UserdataService,
        private helperService: HelperService,
        private router: Router,
        private networkService: NetwordDetectionService,
        private activateComponentService: ActivateComponentService,
        private desktopAppEventsService: DesktopAppEventsService,
        private ebookHelperService: EbookHelperService,
        private desktopEBookVMService: DesktopEBookVMService
    ) {

        // running the constructor's code only in desktop mode
        // running the code in web app was creating error as 
        // definition of BroadcastChannel was not present in window's scope
        // and in strict mode it was stopping from app to load in iOS devices
        if (environment.isDesktopApp) {

            this.downloadingList = new Map();
            this.downloadedList = new Map();
            this.pausedList = new Map();

            this.peDownloadedList = new Map();
            this.peDownloadingList = new Map();
            this.pePausedList = new Map();

            this.getSystemDownloads();
            this.getPESystemDownloads();
            this.resetAvailableDiskSpace();
            this.resetDownloadQueueConfig();
            this.broadcastChannel = new BroadcastChannel("DOWNLOAD_R2R");
            this.broadcastChannel.onmessage = (ev: any) => {


                if (ev.data.type == 'BOOK') {

                    // console.log(ev.data);
                    if (ev.data.response == 'progress') {

                        this.updatePEProgressViaBookProgress(ev.data);

                        switch (ev.data.info.status) {
                            case 'IN_PROGRESS': this.updateProgress(ev.data.info); break;
                            case 'FINISHED': {

                                // in case the finished event is triggered multiple times and the book has already 
                                // been moved from downloading list to downloaded list, do not execute the remaining code
                                this.updateProgress(ev.data.info);
                                let downloadingData = this.downloadingList.get(ev.data.info.productCode);
                                if (downloadingData) {
                                    downloadingData.version = ev.data.info.downloadedVersion;
                                    this.downloadedList.set(ev.data.info.productCode, downloadingData);
                                    this.setEbookDownloadState(ev.data.info.productCode, this.EVENTS.FINISH);
                                    this.downloadingList.delete(ev.data.info.productCode);
                                    if (!this.downloadingList.size) {
                                        clearInterval(this.progressIntervalFunction);
                                        this.progressIntervalFunction = null;
                                    }
                                }

                                delete this.ebookDownloadMap[ev.data.info.productCode];
                                this.setEbookDownloadState(ev.data.info.productCode, this.EVENTS.FINISH);
                                break;
                            }
                            case 'FAILED': {
                            	// console.log('ev.data', ev.data);
                                // console.log('some error occured while downloading');
                                this.setBookForDownloadError(ev.data.info.productCode);
                                $('#downloadingErrorModal').modal('show');
                                this.setError(ev.data.info);
                                break;
                            }
                        }
                    }
                    else if (ev.data.response == 'pause') {
                        let downloadData = this.downloadingList.get(ev.data.productCode);
                        downloadData.wait = false;
                        this.pausedList.set(ev.data.productCode, downloadData);
                        // Add the memory space for the ebook section not downloaded
                        let availableDownloadSize = this.convertToByte(downloadData.unZippedPackagedSize, downloadData.unZippedPackagedUnit) - this.convertToByte(downloadData.downloadedPackageUnzippedSize, downloadData.downloadedPackageUnzippedUnit);
                        // console.log("paused download free space", availableDownloadSize / (1024 * 1024));
                        this.availableDiskSpace = this.availableDiskSpace + availableDownloadSize;

                        // console.log('PAUSE RESPONSE', ev.data);
                        this.downloadingList.delete(ev.data.productCode);

                        this.startEventTimer(ev.data.productCode);

                    }
                    else if (ev.data.response == 'cancel' || ev.data.response == 'saveNcancel') {
                        // console.log('CANCEL RESPONSE', ev.data);
                        this.removeDownloadData(ev.data.productCode).then((dataDelResponse) => {
                            if (dataDelResponse == 'USER_ACCESS_DELETED') {
                                let downloadingData = this.downloadingList.get(ev.data.productCode);
                                let userData = this.userdataService.getLoggedInUser();
                                downloadingData.usersWithAccess.splice(downloadingData.usersWithAccess.indexOf(userData.uid), 1);
                                downloadingData.wait = false;
                                this.pausedList.set(ev.data.productCode, downloadingData);
                                this.setEbookDownloadState(ev.data.productCode, this.EVENTS.REMOVE);
                                this.downloadingList.delete(ev.data.productCode);
                            }
                            else if (dataDelResponse == 'PRODUCT_FOLDER_DELETED') {
                                this.downloadingList.delete(ev.data.productCode)
                                this.setEbookDownloadState(ev.data.productCode, this.EVENTS.REMOVE);
                            }

                            // remove book entry from maps
                            if (this.ebookDownloadMap[ev.data.productCode]) {
                                this.ebookDownloadMap[ev.data.productCode].resolver.resolver();
                            }

                            if (this.bookToLinkedPEProgressMap && this.bookToLinkedPEProgressMap[ev.data.productCode]) {
                                delete this.bookToLinkedPEProgressMap[ev.data.productCode];
                            }

                            delete this.ebookDownloadMap[ev.data.productCode];
                            this.setEbookDownloadState(ev.data.productCode, this.EVENTS.REMOVE);

                            this.downloadChangeNotifier.next(null);
                        });
                    }
                } else if (ev.data.type == 'PE') {

                    if (ev.data.response == 'progress') {
                        switch (ev.data.info.status) {
                            case 'IN_PROGRESS': this.updatePEProgress(ev.data.info); break;
                            case 'FINISHED': {

                                this.updatePEProgress(ev.data.info);
                                // in case the finished event is triggered multiple times and the book has already 
                                // been moved from downloading list to downloaded list, do not execute the remaining code
                                let peDownloadingData = this.peDownloadingList.get(ev.data.info.productCode);
                                if (peDownloadingData) {
                                    peDownloadingData.version = ev.data.info.downloadedVersion;
                                    this.peDownloadedList.set(ev.data.info.productCode, peDownloadingData);
                                    this.peDownloadingList.delete(ev.data.info.productCode);
                                }
                                break;
                            }
                            case 'FAILED': {
                                // console.log('PE download Error');
                                // console.log(ev.data.info);
                                this.peDownloadingList.delete(ev.data.info.productCode);
                                break;
                            }
                        }

                    }
                    else if (ev.data.response == 'pause') {

                        let downloadData = this.peDownloadingList.get(ev.data.productCode);
                        this.pePausedList.set(ev.data.productCode, downloadData);
                        // console.log('PAUSE RESPONSE', ev.data);
                        this.peDownloadingList.delete(ev.data.productCode);

                    } else if (ev.data.response == 'cancel') {
                        this.peDownloadingList.delete(ev.data.productCode);
                        this.removeLinkedPEDownloadData(ev.data.linkedEBook);
                    }
                    // cancel is handled in remove function.
                }

                // desktop app events for download/update end book/pe.

                if (ev.data.response == 'desktopEvent') {

                    let userData = this.userdataService.getLoggedInUser();
                    let category = this.desktopAppEventsService.CONSTANTS.EVENT_CATEGORIES.DOWNLOAD;
                    let action = this.desktopAppEventsService.CONSTANTS.EVENT_ACTIONS.COMPLETE;
                    if (ev.data.eventType == 'downloadStart') {
                        action = this.desktopAppEventsService.CONSTANTS.EVENT_ACTIONS.START;
                    }

                    let type = this.desktopAppEventsService.CONSTANTS.EVENT_DATA_CONTENT_TYPE.BOOK;
                    if (ev.data.type == 'PE') {
                        type = this.desktopAppEventsService.CONSTANTS.EVENT_DATA_CONTENT_TYPE.PE;
                    }

                    let eventObject = this.desktopAppEventsService.generateDownloadEvent(
                        userData.uid, userData.role, ev.data.info.productCode, ev.data.info.downloadedVersion, type, false, ev.data.isUpdateProcess, action, category
                    );
                    this.desktopAppEventsService.generateDesktopEvent(eventObject);
                }

            };

            //Add listener on DOWNLOAD_STARTED for response of DOWNLOAD_START
            window.DLS_IPCListeners && (DLS_IPCListeners.DOWNLOAD_STARTED = (data) => {

                let productCode = data.data.productCode;
                this.startEventTimer(productCode);

                //Set interval to update progress if not already set
                if (!this.progressIntervalFunction) {
                    this.progressIntervalFunction = setInterval(() => {
                        this.broadcastChannel.postMessage({ action: "progress", type: 'BOOK' });
                    }, 10000);
                }
            });

            window.DLS_IPCListeners && (DLS_IPCListeners.PROCESS_ERROR = (data) => {
                // console.log('Error:', data);
                this.router.navigate(['/error-page']);
            });

            window.DLS_IPCListeners && (DLS_IPCListeners.DOWNLOAD_DONE = (data) => {

                console.log('download done for', data.data.productCode);
                if (this.autoUpdateStatus[data.data.productCode]) {

                    this.autoUpdateInProgress = false;

                    if (data.data.autoUpdateStatusObject.updateStatus == 'COMPLETE') {
                        // update book object as complete.
                        this.autoUpdateStatus[data.data.productCode].updateStatus = 'COMPLETE';

                        // in case of PE, update linked book object / stand-alone as complete.
                        if (this.autoUpdateStatus[data.data.productCode].type == 'PE') {
                            this.autoUpdateStatus[data.data.productCode].linkedEBooks.forEach(bookCode => {
                                if (this.autoUpdateStatus[bookCode] && this.autoUpdateStatus[bookCode].onlyPEUpdateNeeded) {

                                    let allPEsCompleted = true;
                                    this.autoUpdateStatus[bookCode].linkedPEs.forEach(peCode => {
                                        if (this.autoUpdateStatus[peCode] && this.autoUpdateStatus[peCode].updateStatus != 'COMPLETE') {
                                            allPEsCompleted = false;
                                        }
                                    });

                                    if (allPEsCompleted) {
                                        this.autoUpdateStatus[bookCode].updateStatus = 'COMPLETE';
                                    }

                                }
                            });
                        }

                        // remove from queue and start auto update of next object.
                        setTimeout(() => {
                            let idx = this.autoUpdateQueue.findIndex((autoUpdateObject) => { return autoUpdateObject.productCode == data.data.productCode });
                            this.autoUpdateQueue.splice(idx, 1);
                            if (this.autoUpdateQueue.length) {
                                this.startAutoUpdating(this.autoUpdateQueue[0]);
                            }
                        }, 500);
                    }

                } else if (this.downloadQueueConfig.currentlyDownloadingProductCodes.indexOf(data.data.productCode) >= 0) {

                    setTimeout(() => {

                        console.log('download done');

                        this.downloadQueueConfig.currentParallelDownloads--;
                        this.downloadQueueConfig.currentlyDownloadingProductCodes = this.downloadQueueConfig.currentlyDownloadingProductCodes.filter(productCode => productCode != data.data.productCode);

                        let pplusCode = this.getpPlusCode(data.data.productCode);
                        let pplusData = this.getpPlusData(pplusCode);
                        let book_lies_in_pplus_product = pplusData && pplusData.product && pplusData.product.pplus.products.find((ebook) => { return ebook['dls-product'].code == data.data.productCode });

                        let downloadable_books = [];
                        if (book_lies_in_pplus_product) {
                            downloadable_books = this.getDownloadableBooksList(pplusData.product, pplusData.space, true, false, false, false);
                        }

                        if (book_lies_in_pplus_product && this.getDownloadedInfoForUser(data.data.productCode) && downloadable_books.length) {
                            this.startPPlusDownload(pplusData.product, pplusData.space, true, [], true);
                        } else {
                            this.invokeDownloadQueue();
                        }

                    }, 500);

                }
                
            });

            this.networkService.monitorStatus().subscribe(async (isOnline) => {
                if (this.isOnline != isOnline) {
                    this.isOnline = isOnline;
                    
                    if (isOnline) {
                        if(this.autoUpdateQueue.length && !this.autoUpdateInProgress){
                            this.startAutoUpdating(this.autoUpdateQueue[0]);
                        }
                    }
                }
            });
            
        }
    }

    /**
     * method to check disk space of a drive
     * @param params (optional): {location: <path-of-drive-or-a folder-or-a-file-inside-drive>}
     * by default returns the info about the drive containing the downloads folder
     * @returns 
     */
    checkDiskSpace(params?){
        return new Promise((resolve, reject) => {
            DLS_IPCCallers
                .CHECK_DISK_SPACE(params)
                .then(res => {
                    if(res.error){
                        reject(res.error);
                    }else{
                        resolve(res);
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    async startDownloading(product) {
        let productCode = product['dls-product'].code;
        let version = product.manifest.version;
        let userData = this.userdataService.getLoggedInUser();


        // check if all PEs are downloaded as well, if know, download PEs.
        if (this.downloadingList.has(productCode)) {
            let downloadingData = this.downloadingList.get(productCode);
            if (downloadingData.usersWithAccess.indexOf(userData.uid) > -1) {
                return;
            } else {
                downloadingData.usersWithAccess.push(userData.uid);
                this.downloadingList.set(productCode, downloadingData);
                this.setEbookDownloadState(productCode, this.EVENTS.START);
            }
        }

        // check if all PEs are downloaded as well, if know, download PEs.
        if (this.downloadedList.has(productCode)) {
            let downloadedData = this.downloadedList.get(productCode);
            if (downloadedData) {
                window.DLS_IPCCallers && DLS_IPCCallers.DB_ADD_USER_ACCESS({
                    productCode,
                    uid: userData.uid
                }).then(() => {
                    downloadedData.usersWithAccess.push(userData.uid);
                    this.downloadedList.set(productCode, downloadedData);
                    this.helperService.getUserSpecificBookData(productCode, { uid: userData.uid });
                    this.downloadQueueConfig.currentParallelDownloads--;
                    this.downloadQueueConfig.currentlyDownloadingProductCodes = this.downloadQueueConfig.currentlyDownloadingProductCodes.filter(downloadingBookCode => productCode != downloadingBookCode);
                    this.invokeDownloadQueue();
                    this.downloadChangeNotifier.next(null);

                    this.setEbookDownloadState(productCode, this.EVENTS.FINISH);


                    // desktop app events for smart download start and end for book.
                    let category = this.desktopAppEventsService.CONSTANTS.EVENT_CATEGORIES.DOWNLOAD;
                    let action = this.desktopAppEventsService.CONSTANTS.EVENT_ACTIONS.START;

                    let type = this.desktopAppEventsService.CONSTANTS.EVENT_DATA_CONTENT_TYPE.BOOK;

                    let eventObject = this.desktopAppEventsService.generateDownloadEvent(
                        userData.uid, userData.role, productCode, this.productToDownloadedVersionMap[productCode], type, true, false, action, category
                    );
                    this.desktopAppEventsService.generateDesktopEvent(eventObject);


                    action = this.desktopAppEventsService.CONSTANTS.EVENT_ACTIONS.COMPLETE;
                    eventObject = this.desktopAppEventsService.generateDownloadEvent(
                        userData.uid, userData.role, productCode, this.productToDownloadedVersionMap[productCode], type, true, false, action, category
                    );
                    this.desktopAppEventsService.generateDesktopEvent(eventObject);


                    // as book was already downloaded, delete the map data.
                    delete this.ebookDownloadMap[productCode];
                });
                return;
            }
        }

        this.helperService.getUserSpecificBookData(productCode, { uid: userData.uid });

        // TODO : Do not filter out PEs, download all available for a book.
        let originalManifest = this.ebookHelperService.getSingleManifest(productCode);
        originalManifest = JSON.parse(JSON.stringify(originalManifest));

        if (originalManifest && originalManifest.data && originalManifest.data.loManifest) {
            
            for (let peCode in originalManifest.data.loManifest) {

                let peVersion = originalManifest.data.loManifest[peCode].shared.productVersion;
                let peUnzippedSize = originalManifest.data.loManifest[peCode].shared.fileSize.unzip;
                let peZippedSize = originalManifest.data.loManifest[peCode].shared.fileSize.zip;
                let peProductCode = peCode;

                originalManifest.data.loManifest[peCode].items.forEach(item => {
                    peUnzippedSize += item.fileSize.unzip;
                    peZippedSize += item.fileSize.zip;
                });

                originalManifest.data.loManifest[peCode] = { peVersion, peUnzippedSize, peZippedSize, peProductCode };

            }
            
        }

        
        let data = {
            // directory: 'zip/',
            /* zipCdnBaseUrl: config.app.zipCdn.baseUrl, */
            apiBaseUrl: config.app.api.baseUrl,
            productCode: productCode,
            version: version,
            uid: userData.uid,
            headers: {
                [AppConfig.customReqHeaders.appVersion.key]: AppConfig.customReqHeaders.appVersion.value
            },
            originalManifest: originalManifest && originalManifest.data,
            type: 'BOOK',
            metadata: {
                downloadStatus: 'NOT_STARTED'
            }
        };


        //Trigger download start to open new browser window
        window.DLS_IPCCallers && DLS_IPCCallers.DOWNLOAD_START(data).then((startResponse) => {
            if (this.pausedList.has(productCode)) {
                let pausedData = this.pausedList.get(productCode);
                pausedData.usersWithAccess.push(userData.uid);
                this.downloadingList.set(productCode, pausedData);
                this.pausedList.delete(productCode);
            } else {
                this.downloadingList.set(productCode, { ...this.downloadDetailsDefault, usersWithAccess: [userData.uid], unZippedPackagedSize: product.manifest.unZippedFileSize, unZippedPackagedUnit: product.manifest.unZippedFileSizeUnit });
            }
            this.downloadChangeNotifier.next(null);

            // console.log("START RECEIVED", startResponse);
        });

    }

    async startValidationAndDownloadBook(product, addToStartOfQueue = false) {
        try {
            let validationResponse: any = await this.validateDownload(product);
            if (validationResponse.isValid) {
                this.addToDownloadQueue(product, addToStartOfQueue);
            }
            return validationResponse;
        } catch (err) {
            console.log(err);
        }
    }

    startPPlusDownload(pplusProduct, space, bypassValidation = false, bypassBooks = [], addToStartOfQueue = false) {
        if (!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);

        if (bypassBooks.length) {
            list_of_downloadable_books = list_of_downloadable_books.filter((book) => { return bypassBooks.indexOf(book['dls-product'].code) == -1 })
        }

        // get paused book from list.
        let paused_book = list_of_downloadable_books.find((book => { return this.getPausedInfoForUser(book['dls-product'].code) }));

        let downloading_book = list_of_downloadable_books.find((book => { return this.getDownloadingInfoForUser(book['dls-product'].code) }));

        if (bypassValidation) {
            this.setPPlusBundleUserActionStateMap(pplusProduct.bundleCode, this.EVENTS.START);
            if (downloading_book) {
                this.startValidationAndDownloadBook(downloading_book, addToStartOfQueue);
                return;
            } else if (paused_book) {
                this.startValidationAndDownloadBook(paused_book, addToStartOfQueue);
            } else {
                if (list_of_downloadable_books.length) {
                    this.startValidationAndDownloadBook(list_of_downloadable_books[0], addToStartOfQueue);
                    if (this.wasBookDownloaded(list_of_downloadable_books[0]['dls-product'].code)) {
                        bypassBooks.push(list_of_downloadable_books[0]['dls-product'].code);
                        setTimeout(() => {
                            this.startPPlusDownload(pplusProduct, space, true, bypassBooks, addToStartOfQueue);
                        }, 500);
                    }
                }
            }
        }

    }
    

    // start auto-updating of book.
    async startAutoUpdating(autoUpdateStatusObject) {

        let isOnline = await this.networkService.isOnline(true);
        if(!isOnline) return;

        if(this.autoUpdateInProgress) {
            return;
        }

        this.autoUpdateInProgress = true;

        let productCode = autoUpdateStatusObject.productCode;
        let version = autoUpdateStatusObject.latestVersion;
        let userData = this.userdataService.getLoggedInUser();

        if (autoUpdateStatusObject.updateStatus == 'NOT_STARTED') {
            await this.removeDownloadedAssetsForAutoUpdatedProduct(autoUpdateStatusObject);
        }

        if (autoUpdateStatusObject.type == 'BOOK' && autoUpdateStatusObject.updateStatus == 'NOT_STARTED') {
            // download new resources.
            this.helperService.getUserSpecificBookData(productCode, { uid: userData.uid });
        }


        // TODO : Get values of unZippedPackagedSize, unZippedPackagedUnit
        // let unZippedPackagedSize, unZippedPackagedUnit;


        let data = {
            apiBaseUrl: config.app.api.baseUrl,
            productCode: productCode,
            version: version,
            uid: userData.uid,
            headers: {
                [AppConfig.customReqHeaders.appVersion.key]: AppConfig.customReqHeaders.appVersion.value
            },
            type: autoUpdateStatusObject.type,
            autoUpdateStatusObject: autoUpdateStatusObject,
            metadata: {
                downloadStatus: 'NOT_STARTED'
            }
        };

        if (autoUpdateStatusObject.type == 'PE') {
            data['linkedEbook'] = autoUpdateStatusObject.linkedEBooks[0]
        }
        
        let { unZippedFileSize, unZippedFileSizeUnit } = this.ebookHelperService.getManifestSize(productCode);


        //Trigger download start to open new browser window
        window.DLS_IPCCallers && DLS_IPCCallers.DOWNLOAD_START(data).then((startResponse) => {
            this.autoUpdateStatus[productCode].updateStatus = 'IN_PROCESS';

            if (data.type == 'BOOK') {
                if (this.pausedList.has(productCode)) {
                    let pausedData = this.pausedList.get(productCode);
                    pausedData.usersWithAccess.push(userData.uid);
                    this.downloadingList.set(productCode, pausedData);
                    this.pausedList.delete(productCode);
                } else {
                    this.downloadingList.set(productCode, { ...this.downloadDetailsDefault, usersWithAccess: [userData.uid], unZippedPackagedSize: unZippedFileSize, unZippedPackagedUnit: unZippedFileSizeUnit });
                }
            } else if (data.type == 'PE') {
                if (this.pePausedList.has(productCode)) {
                    let pausedData = this.pePausedList.get(productCode);
                    this.peDownloadingList.set(productCode, pausedData);
                    this.pePausedList.delete(productCode);
                } else {
                    this.peDownloadingList.set(productCode, { ...this.downloadDetailsDefault, linkedEBooks: data.autoUpdateStatusObject.linkedEBooks, unZippedPackagedSize: '300', unZippedPackagedUnit: 'MB' });
                }
            }

            console.log("AUTO UPDATE RECEIVED", startResponse);
        });



    }

    // remove downloaded content / assets for product before auto-update
    async removeDownloadedAssetsForAutoUpdatedProduct(autoUpdateStatusObject) {

        
        if (autoUpdateStatusObject.type == 'BOOK') {

            let dataDelResponse = window.DLS_IPCCallers && await DLS_IPCCallers.DB_REMOVE_USER_ACCESS({
                productCode: autoUpdateStatusObject.productCode,
                autoUpdateStatusObject: autoUpdateStatusObject
            });

            if (this.downloadedList.has(autoUpdateStatusObject.productCode)) {
                this.downloadedList.delete(autoUpdateStatusObject.productCode)
            }
            if (this.pausedList.has(autoUpdateStatusObject.productCode)) {
                this.pausedList.delete(autoUpdateStatusObject.productCode);
            }
            if (this.downloadingList.has(autoUpdateStatusObject.productCode)) {
                this.downloadingList.delete(autoUpdateStatusObject.productCode);
            }


        } else if (autoUpdateStatusObject.type == 'PE') {

            let dataDelResponse = window.DLS_IPCCallers && await DLS_IPCCallers.DB_PE_REMOVE_LINKED_BOOK({
                peCode: autoUpdateStatusObject.productCode,
                autoUpdateStatusObject: autoUpdateStatusObject
            });

            if (this.peDownloadingList.has(autoUpdateStatusObject.productCode)) {
                this.peDownloadingList.delete(autoUpdateStatusObject.productCode)
            }
            if (this.pePausedList.has(autoUpdateStatusObject.productCode)) {
                this.pePausedList.delete(autoUpdateStatusObject.productCode);
            }
            if (this.peDownloadedList.has(autoUpdateStatusObject.productCode)) {
                this.peDownloadedList.delete(autoUpdateStatusObject.productCode);
            }

        }


    }

    // returns true only if the product is downloaded by the user
    isBookDownloaded(bookCode) {
        let found = false;
        let userData = this.userdataService.getLoggedInUser();
        if(this.downloadedList) {
            this.downloadedList.forEach((data, code) => {
                if(code == bookCode && data.usersWithAccess) {
                    data.usersWithAccess.forEach((el)=> {
                        if(el == userData.uid)
                            found = true;
                    });
                }
            });  
        }
        return found;
    }

    // update autoUpdate object for all the completed books upon navigation.
    updateAutoUpdateObjectOnNavigation() {

        Object.keys(this.autoUpdateStatus).forEach(bookCode => {

            // delete book notes with completed status
            if(this.autoUpdateStatus[bookCode] && this.autoUpdateStatus[bookCode].updateStatus == 'COMPLETE') {
                delete this.autoUpdateStatus[bookCode];
            }

        });
    }

    isPplusUpdated(bundleCode){
        let products= this.getpPlusData(bundleCode)
        let pplusUpdated = true;
        if(products){
            products.product.pplus.products.forEach(product => {
                if(this.autoUpdateStatus[product['dls-product'].code]){
                    if(this.autoUpdateStatus[product['dls-product'].code].updateStatus != 'COMPLETE'){
                        pplusUpdated= false;
                    }
                }
            });
        }
        if(this.isPplusInAutoupdate(bundleCode)){
            return pplusUpdated;
        }else{
            return false;
        }
    }

    isPplusInAutoupdate(bundleCode){
        let products= this.getpPlusData(bundleCode)
        let pplusInAutoupdateObject = false;
        if(products){
            products.product.pplus.products.forEach(product => {
                if(this.autoUpdateStatus[product['dls-product'].code]){
                    pplusInAutoupdateObject = true;
                }
            });
        }
        return pplusInAutoupdateObject;
    }

    validateDownload(product) {
                         
        return new Promise((resolve, reject)=>{
            resolve(_validateDownload(product, this));
        });

                
        function _validateDownload(product, that) {

            let manifest = product.manifest;
            let validationResponse:any = {"isValid" : false};
    
            // [validation rule] book data should be complete
            if(!(manifest && manifest.fileSize)) {
                validationResponse.error = {
                    "type" : "BOOK_DATA",
                    "message": "Book data not available"
                };
                return validationResponse;
            }

            // [validation rule] book data should be complete
            if(manifest && !manifest.hasValidPEManifests) {
                validationResponse.error = {
                    "type" : "PE_DATA_ERROR",
                    "message": "Courses data not available"
                };
                return validationResponse;
            }
            
            //calculating book size in bytes download and resume scenarios
            let downloadableBookSizeInBytes = that.convertToByte(manifest.unZippedFileSize, manifest.unZippedFileSizeUnit);
            let productCode = product['dls-product'].code;
            if(that.pausedList.has(productCode)){
                let pausedData = that.pausedList.get(productCode);
                downloadableBookSizeInBytes = that.convertToByte(pausedData.unZippedPackagedSize,pausedData.unZippedPackagedUnit) - that.convertToByte(pausedData.downloadedPackageUnzippedSize, pausedData.downloadedPackageUnzippedUnit);
            }

            if(downloadableBookSizeInBytes && that.availableDiskSpace && downloadableBookSizeInBytes > that.availableDiskSpace){
                validationResponse.error = {
                    "type" : "OUT_OF_MEMORY",
                    "message": "Free space not available"
                };
                let availableSpace = that.convertBytes(that.availableDiskSpace);
                let requiredSpace = that.convertBytes(downloadableBookSizeInBytes);
                validationResponse.diskUsage = {
                    "availableSpace": availableSpace.size,
                    "availableSpaceUnits": availableSpace.unit,
                    "requiredSpace": requiredSpace.size,
                    "requiredSpaceUnit": requiredSpace.unit
                };
                return validationResponse;
            }
            else{
                // console.log("download space allocated" , downloadableBookSizeInBytes/(1024*1024))
                that.availableDiskSpace -= downloadableBookSizeInBytes;
            }
            // [validation rule] manifest data should be available
            // if(!(manifest && manifest.shared && manifest.shared.productVersion)) {
            //     validationResponse.error = {
            //         "type" : "MANIFEST_DATA",
            //         "message": "Manifest data not available"
            //     };
            //     return validationResponse;
    
            // }
    
            // if(book.book.meta.currentversion != manifest.shared.productVersion) {
                // validationResponse.error = {
                //     "type" : "VERSION_MISMATCH",
                //     "message": "ZIP Packages are not copied completely. Please try again after sometime"
                // };
                // return validationResponse;
            // }
    
            validationResponse.isValid = true;
            return validationResponse;
    
        }
    }

    pauseDownloading(productCode) {
        if (this.downloadingList.has(productCode) && this.downloadingList.get(productCode).progress != 100) {
            let downloadData = this.downloadingList.get(productCode);
            downloadData.wait = true;
            this.downloadingList.set(productCode, downloadData);
            this.setEbookDownloadState(productCode, this.EVENTS.PAUSE);
            this.broadcastChannel.postMessage({ action: "pause", productCode: productCode, type: 'BOOK' });
            if (!this.downloadingList.size) {
                clearInterval(this.progressIntervalFunction);
                this.progressIntervalFunction = null;
            }
        }
    }

    async pauseAllDownloading() {
        this.downloadingList.forEach((downloadingData, productCode) => {
            this.initiatePauseDownloading(productCode);
        })
        return new Promise((resolve, reject) => {
            let loop = () => {
                if (!this.downloadingList.size) {
                    return resolve(null);
                }
                setTimeout(loop, 1000);
            }
            loop();
        });
    }

    async removeDownload(product) {
        let productCode = product.productCode;

        this.downloadChangeNotifier.next(null);
        this.setEbookDownloadState(productCode, this.EVENTS.REMOVE);
        delete this.autoUpdateStatus[productCode];


        if (this.downloadingList.has(productCode) && this.downloadingList.get(productCode).progress != 100) {
            let downloadData = this.downloadingList.get(productCode);
            downloadData.wait = true;
            this.downloadingList.set(productCode, downloadData);
            if (product.product && product.product.manifest) {
                let downloadableBookSizeInBytes = this.convertToByte(product.product.manifest.unZippedFileSize, product.product.manifest.unZippedFileSizeUnit);
                // console.log("downloadablebook with intial size 0", product.product.manifest.unZippedFileSize);
                this.availableDiskSpace += downloadableBookSizeInBytes;
            }
            if (downloadData.usersWithAccess.length > 1) {
                this.broadcastChannel.postMessage({ action: "saveNcancel", productCode: productCode, type: 'BOOK' });
            } else {
                this.broadcastChannel.postMessage({ action: "cancel", productCode: productCode, type: 'BOOK' });
            }
            if (!this.downloadingList.size) {
                clearInterval(this.progressIntervalFunction);
                this.progressIntervalFunction = null;
            }
        } else {
            let dataDelResponse = await this.removeDownloadData(productCode);
            if (dataDelResponse == 'USER_ACCESS_DELETED') {
                if (this.pausedList.has(productCode)) {
                    let pausedData = this.pausedList.get(productCode);
                    let userData = this.userdataService.getLoggedInUser();
                    pausedData.usersWithAccess.splice(pausedData.usersWithAccess.indexOf(userData.uid), 1);
                    this.pausedList.set(productCode, pausedData);
                } else if (this.downloadedList.has(productCode)) {
                    let downloadedData = this.downloadedList.get(productCode);
                    let userData = this.userdataService.getLoggedInUser();
                    downloadedData.usersWithAccess.splice(downloadedData.usersWithAccess.indexOf(userData.uid), 1);
                    this.downloadedList.set(productCode, downloadedData);
                }
            }
            else if (dataDelResponse == 'PRODUCT_FOLDER_DELETED') {
                if (this.pausedList.has(productCode)) {
                    let downloadData = this.pausedList.get(productCode);
                    //Add the memory space for the ebook already downloaded
                    this.availableDiskSpace = this.availableDiskSpace + this.convertToByte(downloadData.downloadedPackageUnzippedSize, downloadData.downloadedPackageUnzippedUnit);
                    // console.log("pause downloaded space free", (downloadData.downloadedPackageUnzippedSize));
                    this.pausedList.delete(productCode);
                } else if (this.downloadedList.has(productCode)) {
                    // let downloadedData = this.downloadedList.get(productCode);
                    if (product.product && product.product.manifest) {
                        let bookSize = this.convertToByte(product.product.manifest.unZippedFileSize, product.product.manifest.unZippedFileSizeUnit);
                        // console.log("removed space free", bookSize);
                        this.availableDiskSpace = this.availableDiskSpace + bookSize;
                    }
                    this.downloadedList.delete(productCode);
                }
            }
            this.removeDownloadNotifier.next(null);

            // remove book entry from maps
            if (this.ebookDownloadMap[productCode]) {
                this.ebookDownloadMap[productCode].resolver.resolver();
            }

            if (this.bookToLinkedPEProgressMap && this.bookToLinkedPEProgressMap[productCode]) {
                delete this.bookToLinkedPEProgressMap[productCode];
            }

            delete this.ebookDownloadMap[productCode];

        }
        this.helperService.delUserSpecificBookData(productCode, { "uid": this.userdataService.getLoggedInUser().uid });
    }

    isDownloadOrAutoUpdateInProgress() {
        return this.isDownloadInProgress() || this.isAutoUpdateInProgress();
    }

    isDownloadInProgress() {
        return !!this.downloadingList.size;
    }

    isAutoUpdateInProgress() {
        return this.autoUpdateInProgress;
    }
    
    async removeDownloadData(productCode) {
        //Remove entry from DB
        let userData = this.userdataService.getLoggedInUser();
        let dataDelResponse = window.DLS_IPCCallers && await DLS_IPCCallers.DB_REMOVE_USER_ACCESS({
            productCode,
            uid: userData.uid
        });

        if (dataDelResponse == 'PRODUCT_FOLDER_DELETED' || dataDelResponse == null) {
            await this.removeLinkedPEDownloadData(productCode);
        }

        return dataDelResponse;
    }

    async removeLinkedPEDownloadData(bookCode) {


        if (this.ebookToPEMap[bookCode]) {
            for (let peCode of this.ebookToPEMap[bookCode]) {

                let isDownloading = false;
                if(this.peDownloadingList.get(peCode)) {
                    isDownloading = true;
                }

                let peRemoveDownloadResponse = window.DLS_IPCCallers && await DLS_IPCCallers.DB_PE_REMOVE_LINKED_BOOK({
                    peCode: peCode,
                    linkedEBook: bookCode,
                    isDownloading: isDownloading
                });

                // console.log(peRemoveDownloadResponse);

                if (peRemoveDownloadResponse == 'USER_ACCESS_DELETED') {

                    if (this.peDownloadingList.get(peCode)) {
                        let downloadingData = this.peDownloadingList.get(peCode);
                        downloadingData.linkedEBooks.splice(downloadingData.linkedEBooks.indexOf(bookCode), 1);
                        if(downloadingData.linkedEBooks.length) {
                            this.peDownloadingList.set(peCode, downloadingData);
                        } else {
                            this.pePausedList.set(peCode, downloadingData);
                        }
                    }
                    if (this.pePausedList.has(peCode)) {
                        let pausedData = this.pePausedList.get(peCode);
                        pausedData.linkedEBooks.splice(pausedData.linkedEBooks.indexOf(bookCode), 1);
                        this.pePausedList.set(peCode, pausedData);
                    }
                    if (this.peDownloadedList.has(peCode)) {
                        let downloadedData = this.peDownloadedList.get(peCode);
                        downloadedData.linkedEBooks.splice(downloadedData.linkedEBooks.indexOf(bookCode), 1);
                        this.peDownloadedList.set(peCode, downloadedData);
                    }
                } else if (peRemoveDownloadResponse == 'PRODUCT_FOLDER_DELETED' || peRemoveDownloadResponse == null) {

                    if (this.peDownloadingList.has(peCode)) {
                        this.peDownloadingList.delete(peCode)
                    }
                    if (this.pePausedList.has(peCode)) {
                        this.pePausedList.delete(peCode);
                    }
                    if (this.peDownloadedList.has(peCode)) {
                        this.peDownloadedList.delete(peCode);
                    }

                }

            }
        }
    }

    //Convert bytes to data units
    convertBytes(bytes, decimals = 2) {
        if (bytes == 0) return 0;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return {
            size: parseFloat((bytes / Math.pow(1024, i)).toFixed(decimals)),
            unit: sizes[i]
        }

    }

    updateProgress(data, decimals = 2) {
        let downloadDetails = this.downloadingList.get(data.productCode);

        if (downloadDetails) {

            //If total size not set , then set it
            if (downloadDetails.totalPackageSize == 0 || downloadDetails.totalPackageSize == undefined) {
                let totalByteDetail: any = this.convertBytes(data.download.totalPackageSize);
                downloadDetails.totalPackageSize = totalByteDetail.size;
                downloadDetails.downloadUnit = totalByteDetail.unit;
                downloadDetails.location = data.location;
            }

            if (data.progress > downloadDetails.progress) {
                downloadDetails.progress = data.progress;
            }

            let byteDetail: any = this.convertBytes(data.download.downloadedPackageSize);
            downloadDetails.downloadedPackageSize = byteDetail.size;
            downloadDetails.usersWithAccess = data.usersWithAccess;
            let unzippedDetails: any = this.convertBytes(data.download.downloadedPackageUnzippedSize);
            downloadDetails.downloadedPackageUnzippedSize = unzippedDetails.size ? unzippedDetails.size : 0;
            downloadDetails.downloadedPackageUnzippedUnit = unzippedDetails.unit ? unzippedDetails.unit : '--';
            this.downloadingList.set(data.productCode, downloadDetails);
        }
    }

    updatePEProgress(data, decimals = 2) {
        let downloadDetails = this.peDownloadingList.get(data.productCode);

        if(downloadDetails && data.progress > downloadDetails.progress ) {
            downloadDetails.progress = data.progress;
        }

        this.peDownloadingList.set(data.productCode, downloadDetails);
    }

    updatePEProgressViaBookProgress(data) {

        let PEs = data && data.info && data.info.linkedPEs;

        Object.keys(PEs).forEach((PECode) => {

            let downloadData = PEs[PECode];
            // console.log('PE status', downloadData.status);
            if (downloadData.status == "IN_PROGRESS") {
                this.peDownloadingList.set(PECode, downloadData);
                this.pePausedList.delete(PECode);
                this.peDownloadedList.delete(PECode);
            } else if (downloadData.status == "FINISHED") {
                this.peDownloadedList.set(PECode, downloadData);
                this.pePausedList.delete(PECode);
                this.peDownloadingList.delete(PECode);
            } else {
                this.pePausedList.set(PECode, downloadData);
                this.peDownloadedList.delete(PECode);
                this.peDownloadingList.delete(PECode);
            }

            if(!this.bookToLinkedPEProgressMap[data.info.productCode]) {                
                this.bookToLinkedPEProgressMap[data.info.productCode] = {};
            }
            
            if(!this.bookToLinkedPEProgressMap[data.info.productCode][PECode]) {                
                this.bookToLinkedPEProgressMap[data.info.productCode][PECode] = {};
            }

            this.bookToLinkedPEProgressMap[data.info.productCode][PECode] = downloadData;

        });

        console.log(JSON.parse(JSON.stringify(this.bookToLinkedPEProgressMap)));


        
    }

    setError(data) {
        let downloadDetails = this.downloadingList.get(data.productCode);
        if (downloadDetails) {
            downloadDetails.error = data.error;
            this.pausedList.set(data.productCode, downloadDetails);
            this.downloadingList.delete(data.productCode);
            this.setEbookDownloadState(data.productCode, this.EVENTS.PAUSE);
        }
    }

    async getSystemDownloads() {

        let downloadsList = await DLS_IPCCallers.DB_GET_DOWNLOADS();
        console.log('Book downloadsList');
        console.log(downloadsList);

        let downloadDetail, totalByteDetail, byteDetail, unzippedDetails;
        downloadsList && downloadsList.forEach(downloadData => {

            downloadDetail = {
                progress: downloadData.progress,
                location: downloadData.location,
                totalPackageSize: 0,
                downloadedPackageSize: 0,
                downloadUnit: '--',
                usersWithAccess: downloadData.usersWithAccess,
                downloadedPackageUnzippedSize: 0,
                downloadedPackageUnzippedUnit: '--',
                version: downloadData.downloadedVersion,
                autoUpdateStatus: downloadData.metadata && downloadData.metadata.autoUpdateStatus
            };

            this.autoUpdateStatus[downloadData.productCode] = downloadData.metadata && downloadData.metadata.autoUpdateStatus ? JSON.parse(JSON.stringify(downloadData.metadata.autoUpdateStatus)) : undefined;


            if (downloadData.download && downloadData.download.totalPackageSize) {
                totalByteDetail = this.convertBytes(downloadData.download.totalPackageSize);
                downloadDetail.totalPackageSize = totalByteDetail.size;
                downloadDetail.downloadUnit = totalByteDetail.unit;
            }

            if (downloadData.download && downloadData.download.downloadedPackageSize) {
                byteDetail = this.convertBytes(downloadData.download.downloadedPackageSize);
                downloadDetail.downloadedPackageSize = byteDetail.size;
            }

            if (downloadData.download && downloadData.download.downloadedPackageUnzippedSize) {
                unzippedDetails = this.convertBytes(downloadData.download.downloadedPackageUnzippedSize);
                downloadDetail.downloadedPackageUnzippedSize = unzippedDetails.size;
                downloadDetail.downloadedPackageUnzippedUnit = unzippedDetails.unit;
            }

            if (downloadData.status == "FINISHED") {
                this.downloadedList.set(downloadData.productCode, downloadDetail);
            } else if (downloadData) {
                this.pausedList.set(downloadData.productCode, downloadDetail);
            }

        });

    }

    // get status of all PEs in DB.
    // TODO: there is a scenario where LO download can be stuck. When we start LO download, we check if the LO is in progress,
    // if yes, then we just send out event and do not actually start the download. However in case no other LO download was started,
    // the empty process may just keep idle. This will give an impression of download stuck. To fix this we should check if any LO is in-progress
    // on app launch and change it to paused. This way on we will be able to prevent the LO stuck issue.
    async getPESystemDownloads() {

        let downloadsList = await DLS_IPCCallers.DB_PE_GET_DOWNLOADS();
        console.log('PE downloadsList');
        console.log(downloadsList);

        let downloadDetail, totalByteDetail, byteDetail, unzippedDetails;
        downloadsList && downloadsList.forEach(downloadData => {

            // add data as required. to downloaded, downloading and paused lists.
            downloadDetail = {
                progress: downloadData.progress,
                location: downloadData.location,
                totalPackageSize: 0,
                downloadedPackageSize: 0,
                downloadUnit: '--',
                linkedEBooks: downloadData.linkedEBooks,
                downloadedPackageUnzippedSize: 0,
                downloadedPackageUnzippedUnit: '--',
                version: downloadData.downloadedVersion,
                autoUpdateStatus: downloadData.metadata && downloadData.metadata.autoUpdateStatus
            };

            this.autoUpdateStatus[downloadData.productCode] = downloadData.metadata && downloadData.metadata.autoUpdateStatus ? JSON.parse(JSON.stringify(downloadData.metadata.autoUpdateStatus)) : undefined;

            if (downloadData.download && downloadData.download.totalPackageSize) {
                totalByteDetail = this.convertBytes(downloadData.download.totalPackageSize);
                downloadDetail.totalPackageSize = totalByteDetail.size;
                downloadDetail.downloadUnit = totalByteDetail.unit;
            }

            if (downloadData.download && downloadData.download.downloadedPackageSize) {
                byteDetail = this.convertBytes(downloadData.download.downloadedPackageSize);
                downloadDetail.downloadedPackageSize = byteDetail.size;
            }

            if (downloadData.download && downloadData.download.downloadedPackageUnzippedSize) {
                unzippedDetails = this.convertBytes(downloadData.download.downloadedPackageUnzippedSize);
                downloadDetail.downloadedPackageUnzippedSize = unzippedDetails.size;
                downloadDetail.downloadedPackageUnzippedUnit = unzippedDetails.unit;
            }

            if (downloadData.status == 'FINISHED') {
                this.peDownloadedList.set(downloadData.productCode, downloadDetail);
                this.setPEDownloadState(downloadData.productCode, this.EVENTS.FINISH);
            } else if (downloadData) {
                this.pePausedList.set(downloadData.productCode, downloadDetail);
                this.setPEDownloadState(downloadData.productCode, this.EVENTS.PAUSE);
            }

        });

    }

    updateSystemDownloads() {
        this.getSystemDownloads();
        this.getPESystemDownloads();
    }

    getDownloadingInfoForUser(productCode) {
        let userData = this.userdataService.getLoggedInUser();
        if (userData) {
            let downloadingInfo = this.downloadingList.get(productCode);
            if (downloadingInfo && downloadingInfo.usersWithAccess.indexOf(userData.uid) > -1) {

                let totalProgress = downloadingInfo.progress;
                let peLength = this.ebookToPEMap[productCode] ? this.ebookToPEMap[productCode].length : 0;

                peLength && this.ebookToPEMap[productCode].forEach((peCode) => {
                    let peDownloadInfo = this.bookToLinkedPEProgressMap && this.bookToLinkedPEProgressMap[productCode] && this.bookToLinkedPEProgressMap[productCode][peCode];
                    if (peDownloadInfo && peDownloadInfo.linkedEBooks && peDownloadInfo.linkedEBooks.indexOf(productCode) > -1) {
                        let progress = peDownloadInfo ? peDownloadInfo.progress : 0;
                        totalProgress += progress > 100 ? 100 : progress;
                    }
                });

                if (totalProgress < 5) {
                    totalProgress = 5
                }

                downloadingInfo.totalProgress = totalProgress / (1 + peLength);
                return downloadingInfo;
            }
        }
    }

    getDownloadedInfoForUser(productCode) {
        let userData = this.userdataService.getLoggedInUser();
        if (userData) {
            let downloadedInfo = this.downloadedList.get(productCode);
            if (downloadedInfo && downloadedInfo.usersWithAccess.indexOf(userData.uid) > -1) {

                let totalProgress = downloadedInfo.progress;
                let peLength = this.ebookToPEMap[productCode] ? this.ebookToPEMap[productCode].length : 0;

                peLength && this.ebookToPEMap[productCode].forEach((peCode) => {
                    let peDownloadInfo = this.bookToLinkedPEProgressMap && this.bookToLinkedPEProgressMap[productCode] && this.bookToLinkedPEProgressMap[productCode][peCode];
                    if (peDownloadInfo && peDownloadInfo.linkedEBooks && peDownloadInfo.linkedEBooks.indexOf(productCode) > -1) {
                        let progress = peDownloadInfo ? peDownloadInfo.progress : 0;
                        totalProgress += progress > 100 ? 100 : progress;
                    }
                });

                if (totalProgress < 5) {
                    totalProgress = 5
                }

                downloadedInfo.totalProgress = totalProgress / (1 + peLength);
                return downloadedInfo;
            }
        }
    }

    getPausedInfoForUser(productCode) {
        let userData = this.userdataService.getLoggedInUser();
        if (userData) {
            let pausedInfo = this.pausedList.get(productCode);
            if (pausedInfo && pausedInfo.usersWithAccess.indexOf(userData.uid) > -1) {

                let totalProgress = pausedInfo.progress;
                let peLength = this.ebookToPEMap[productCode] ? this.ebookToPEMap[productCode].length : 0;

                peLength && this.ebookToPEMap[productCode].forEach((peCode) => {
                    let peDownloadInfo = this.bookToLinkedPEProgressMap && this.bookToLinkedPEProgressMap[productCode] && this.bookToLinkedPEProgressMap[productCode][peCode];
                    if (peDownloadInfo && peDownloadInfo.linkedEBooks && peDownloadInfo.linkedEBooks.indexOf(productCode) > -1) {
                        let progress = peDownloadInfo ? peDownloadInfo.progress : 0;
                        totalProgress += progress > 100 ? 100 : progress;
                    }
                });

                if (totalProgress < 5) {
                    totalProgress = 5
                }

                pausedInfo.totalProgress = totalProgress / (1 + peLength);
                return pausedInfo;
            }
        }
    }

    convertToByte(bytes, unit){
        if (bytes == 0) return 0;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        return  bytes*Math.pow(1024,(sizes.indexOf(unit)));
    }

    resetAvailableDiskSpace(){
        this.checkDiskSpace()
                .then(res => {
                    // console.log("Disk Usage: ", res);
                    this.availableDiskSpace = res["free"] - this.availableDiskBufferSpace;
                    console.log('original size : ', this.availableDiskSpace);
                    
                    let newSpace = localStorage.getItem('hardCodedSpace');
                    if(newSpace) {
                        this.availableDiskSpace = newSpace;
                        console.log('new size : ', this.availableDiskSpace);
                    }

                
                })
                .catch(err => {
                    // console.log("error in checking disk space: ", err);
                }); 
    }

    resetPPlusBookCodesArray(){
        this.pplusBookcodes = [];
    }

    getAvailableDiskSpace() {
        return this.availableDiskSpace;
    }

    blockAvailableDiskSpace(downloadableBookSizeInBytes) {
        this.availableDiskSpace -= downloadableBookSizeInBytes;
    }

    wasBookDownloaded(productCode) {
        return this.downloadedList.get(productCode);
    }

    addPPlusbooks(productCode){
        this.pplusBookcodes.push(productCode);
    }
    
    setBookForDownloadError(productCode){
        this.bookForDownloadError = productCode;
    }

    getDownloadingBookCode() {
        let downloadingEbook = this.bookForDownloadError;
        if (downloadingEbook) {
            if (this.pplusBookcodes.indexOf(downloadingEbook) != -1) {
                return "pplus";
            }
            else {
                return downloadingEbook;
            }
        }
    }

    async addToMap(bookCode, event, product?, removeData?) {

        // create and set objects and data
        if (!this.ebookDownloadMap.hasOwnProperty(bookCode)) {
            this.ebookDownloadMap[bookCode] = {};
            this.ebookDownloadMap[bookCode].eventsArray = [];
        }

        if (product) {
            this.ebookDownloadMap[bookCode].product = product;
        }

        if (removeData) {
            this.ebookDownloadMap[bookCode].removeData = removeData;
        }
        
        if (!this.ebookDownloadStateMap.hasOwnProperty(bookCode)) {
            this.ebookDownloadStateMap[bookCode] = undefined;
        }
        this.setEbookDownloadState(bookCode, event);

        this.downloadChangeNotifier.next(null);

        // if event in progress, add event to array, do nothing
        // else, set the flag, trigger the event
        if (this.ebookDownloadMap[bookCode].eventInProgress) {

            if (event == this.EVENTS.REMOVE) {

                const [myPromise, myResolver] = this.createPromise();
                this.ebookDownloadMap[bookCode].resolver = { resolver: myResolver };
                this.ebookDownloadMap[bookCode].eventsArray.push(event);
                return myPromise;

            } else {
                this.ebookDownloadMap[bookCode].eventsArray.push(event);
            }

        } else {

            this.ebookDownloadMap[bookCode].eventInProgress = true;
            if (event == this.EVENTS.PAUSE) {
                this.ebookDownloadMap[bookCode].currentEvent = this.EVENTS.PAUSE;
                this.pauseDownloading(bookCode);
            } else if (event == this.EVENTS.START) {
                this.ebookDownloadMap[bookCode].currentEvent = this.EVENTS.START;
                this.startDownloading(this.ebookDownloadMap[bookCode].product)
            } else if(event == this.EVENTS.REMOVE) {
                const [myPromise, myResolver] = this.createPromise();
                this.ebookDownloadMap[bookCode].resolver = { resolver: myResolver };
                this.ebookDownloadMap[bookCode].currentEvent = this.EVENTS.REMOVE;
                this.removeDownload(this.ebookDownloadMap[bookCode].removeData)
                return myPromise
            }

        }
        
        
    }
    
    initiateRemoveDownloading(productData) {
        return this.addToMap(productData.productCode, this.EVENTS.REMOVE, undefined, productData);
    }

    initiatePauseDownloading(productCode) {
        this.addToMap(productCode, this.EVENTS.PAUSE);
    }

    initiateStartDownloading(product) {
        let productCode = product['dls-product'].code;
        this.downloadQueueConfig.currentlyDownloadingProductCodes.push(productCode);
        this.downloadQueueConfig.currentParallelDownloads++;
        this.addToMap(productCode, this.EVENTS.START, product);
    }

    addToDownloadQueue(product, addToStartOfQueue = false) {
        console.log('add to queue');
        console.log(product);

        let queuedDownloadProduct = this.downloadQueueConfig.productDownloadQueue.find(queuedProduct => queuedProduct['dls-product'].code == product['dls-product'].code);

        if (!queuedDownloadProduct) {
            if (addToStartOfQueue) {
                this.downloadQueueConfig.productDownloadQueue.unshift(product);
                this.downloadQueueConfig.currentlyQueuedProductCodes.unshift(product['dls-product'].code);
            } else {
                this.downloadQueueConfig.productDownloadQueue.push(product);
                this.downloadQueueConfig.currentlyQueuedProductCodes.push(product['dls-product'].code);
            }
            this.invokeDownloadQueue();
        }

    }

    removeFromDownloadQueue(productCode) {
        console.log('remove from queue', productCode);
        this.downloadQueueConfig.productDownloadQueue = this.downloadQueueConfig.productDownloadQueue.filter(queuedProduct => productCode != queuedProduct['dls-product'].code);
        this.downloadQueueConfig.currentlyQueuedProductCodes = this.downloadQueueConfig.currentlyQueuedProductCodes.filter(queuedProductCode => productCode != queuedProductCode);
    }

    removePplusFromDownloadQueue(pplusProduct, space) {
        if (!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);

        list_of_downloadable_books.forEach(book => {
            this.removeFromDownloadQueue(book['dls-product'].code);
        });
    }

    invokeDownloadQueue() {
        setTimeout(() => {

            console.log('invoke queue');
            console.log('this.downloadQueueConfig.currentParallelDownloads, this.downloadQueueConfig.maxParallelDownloadsAllowed', this.downloadQueueConfig.currentParallelDownloads, this.downloadQueueConfig.maxParallelDownloadsAllowed)
            if (this.downloadQueueConfig.currentParallelDownloads < this.downloadQueueConfig.maxParallelDownloadsAllowed) {
                let product = this.downloadQueueConfig.productDownloadQueue.shift();
                this.downloadQueueConfig.currentlyQueuedProductCodes = this.downloadQueueConfig.currentlyQueuedProductCodes.filter(productCode => productCode != product['dls-product'].code);
                if (product) {
                    this.initiateStartDownloading(product);
                }
            }

        }, 50);
    }

    isBookDownloadQueued(bookCode) {
        return this.downloadQueueConfig.currentlyQueuedProductCodes.indexOf(bookCode) > -1;
    }

    getLastEvent(bookCode) {
        return this.ebookDownloadStateMap && this.ebookDownloadStateMap[bookCode] != this.EVENTS.REMOVE ? this.ebookDownloadStateMap[bookCode] : undefined
    }

    getPausedButtonState(bookCode) {
        if (this.getLastEvent(bookCode) == this.EVENTS.START) {
            return true;
        } else {
            if (this.getLastEvent(bookCode) == undefined && this.getDownloadingInfoForUser(bookCode)) {
                return true;
            }
        }
        return false;
    }

    getResumeButtonState(bookCode) {
        if (this.getLastEvent(bookCode) == this.EVENTS.PAUSE) {
            return true;
        } else {
            if (this.getLastEvent(bookCode) == undefined && this.getPausedInfoForUser(bookCode)) {
                return true;
            }
        }
        return false;
    }

    startEventTimer(bookCode) {

        // start a timeout of 2 secs.
        // after 2 secs,
        // if event array is empty, reset flag,
        // else set flag, send last event to Backend, empty array.

        setTimeout(async () => {

            if (this.ebookDownloadMap[bookCode]) {

                if (this.ebookDownloadMap[bookCode].eventsArray.length > 0) {
                    let event = this.ebookDownloadMap[bookCode].eventsArray.pop();
                    this.ebookDownloadMap[bookCode].eventsArray = [];

                    if(event == this.ebookDownloadMap[bookCode].currentEvent) {
                        this.ebookDownloadMap[bookCode].eventInProgress = false;
                        return;
                    }

                    if (event == this.EVENTS.PAUSE) {
                        this.ebookDownloadMap[bookCode].currentEvent = this.EVENTS.PAUSE;
                        this.pauseDownloading(bookCode);
                    } else if (event == this.EVENTS.START) {
                        this.ebookDownloadMap[bookCode].currentEvent = this.EVENTS.START;
                        this.startDownloading(this.ebookDownloadMap[bookCode].product)
                    } else if(event == this.EVENTS.REMOVE) {
                        this.ebookDownloadMap[bookCode].currentEvent = this.EVENTS.REMOVE;
                        return this.removeDownload(this.ebookDownloadMap[bookCode].removeData)
                    }
                    this.ebookDownloadMap[bookCode].eventInProgress = true;
                } else {
                    this.ebookDownloadMap[bookCode].eventInProgress = false;
                }
            }

        }, 2*1000);

    }

    createPromise() {
        let resolver;
        return [
            new Promise((resolve, reject) => {
                resolver = resolve;
            }),
            resolver,
        ];
    }

    setEbookDownloadState(bookCode, state) {
        this.ebookDownloadStateMap[bookCode] = state;
        // console.log(bookCode, state);
        this.updatePPlusDownloadMap();
        this.downloadChangeNotifier.next(null);
    }

    setPEDownloadState(peCode, state) {
        this.ebookDownloadStateMap[peCode] = state;
    }

    updateDownloadedEbookState() {
        let userData = this.userdataService.getLoggedInUser();

        this.downloadedList.forEach((value, key) => {
            if (value.usersWithAccess.indexOf(userData.uid) > -1) {
                this.setEbookDownloadState(key, this.EVENTS.FINISH);
            }
        });

        this.pausedList.forEach((value, key) => {
            if (value.usersWithAccess.indexOf(userData.uid) > -1) {
                this.setEbookDownloadState(key, this.EVENTS.PAUSE);
            }
        });


        this.peDownloadedList.forEach((value, key) => {
            value.linkedEBooks.forEach(book => {
                if (!this.bookToLinkedPEProgressMap[book]) {
                    this.bookToLinkedPEProgressMap[book] = {};
                }
                if (!this.bookToLinkedPEProgressMap[book][key]) {
                    this.bookToLinkedPEProgressMap[book][key] = {}
                }
                this.bookToLinkedPEProgressMap[book][key] = value;
            });
        });

        this.pePausedList.forEach((value, key) => {
            value.linkedEBooks.forEach(book => {
                if (!this.bookToLinkedPEProgressMap[book]) {
                    this.bookToLinkedPEProgressMap[book] = {};
                }
                if (!this.bookToLinkedPEProgressMap[book][key]) {
                    this.bookToLinkedPEProgressMap[book][key] = {}
                }
                this.bookToLinkedPEProgressMap[book][key] = value;
            });
        });

        this.updateProductToDownloadedVersionMap();
        this.removeAutoUpdateStatusOfBooksNotDownloadedByCurrentUser();

    }

    resetDownloadQueueConfig() {
        this.downloadQueueConfig = {
            maxParallelDownloadsAllowed: 3,
            currentParallelDownloads: 0,
            productDownloadQueue: [],
            currentlyDownloadingProductCodes: [],
            currentlyQueuedProductCodes: []
        }
    }

    resetEbookDownloadState() {
        this.ebookDownloadStateMap = {};
        this.ebookToPEMap = {};
        this.PEtoEBookMap = {};
        this.bookToLinkedPEProgressMap = {};
        this.autoUpdateQueue = [];
        this.resetDownloadQueueConfig();
        this.resetPPlusDownloadState();
    }

    // called when manifest call is successful, to upload downloading lists.
    updateBookAndPEMap(manifestList) {


        // map all ebooks with linked PEs
        manifestList.forEach((manifest) => {
            this.ebookToPEMap[manifest.ebookCode] = manifest && manifest.data && manifest.data.loManifest && Object.keys(manifest.data.loManifest)
        });


        Object.keys(this.ebookToPEMap).forEach(bookCode => {
            if (this.ebookToPEMap[bookCode]) {
                this.ebookToPEMap[bookCode].forEach(peCode => {
                    if (!this.PEtoEBookMap[peCode]) {
                        this.PEtoEBookMap[peCode] = [];
                    }

                    if(this.PEtoEBookMap[peCode].indexOf(bookCode) == -1) {
                        this.PEtoEBookMap[peCode].push(bookCode);
                    }
                })
            }
        })

        console.log('ebook to PE Maps');
        console.log(this.ebookToPEMap);
        console.log(this.PEtoEBookMap);

    }

    updateProductToDownloadedVersionMap() {

        
        this.downloadedList.forEach((value, key) => {
            this.productToDownloadedVersionMap[key] = value.version || value.downloadedVersion;
        });

        this.pausedList.forEach((value, key) => {
            this.productToDownloadedVersionMap[key] = value.version || value.downloadedVersion;
        });

        this.peDownloadedList.forEach((value, key) => {
            this.productToDownloadedVersionMap[key] = value.version || value.downloadedVersion;
        });

        this.pePausedList.forEach((value, key) => {
            this.productToDownloadedVersionMap[key] = value.version || value.downloadedVersion;
        });

        // console.log(this.productToDownloadedVersionMap);
    }

    getProductToDownloadedVersionMap() {
        return this.productToDownloadedVersionMap;
    }

    // start auto-update process for current batch of manifests.
    async initiateAutoUpdateProcess(manifestList) {

        // do not auto-update in offline mode.
        let isOnline = await this.networkService.isOnline(true);
        if (!isOnline) {
            return;
        }

        // generate auto-update Object from DB, update it based on data fetched from server and store it in memory.
        this.checkForContentAutoUpdate(manifestList);

        // generate a map of users with access to the book / PE.
        this.generateBookToUsersWithAccessMap(manifestList);

        // generate update Download Lists and add the auto-update object to DB.
        await this.updateDownloadListsAndDBWithAutoUpdateStatus(manifestList);

        // create an auto-update Queue and start downloading.
        this.createAutoUpdateQueue(manifestList);
    }

    checkForContentAutoUpdate(manifestList) {

        let latestBookVersionMap = {};

        // get the latest version of all the books.
        manifestList.forEach(manifestData => {
            latestBookVersionMap[manifestData.ebookCode] = manifestData.data.manifest && manifestData.data.manifest.shared.productVersion;
        });

        // iterate over the latest manifest data recieved to create the auto-update object.
        manifestList.forEach(manifestData => {
            // only check for books that have been downloaded. Linked PE will belong to some downloaded book only. No orphan PEs.
            if (manifestData.data.manifest && Object.keys(this.productToDownloadedVersionMap).indexOf(manifestData.ebookCode) > -1) {

                // object will be filled for 1 book only.
                if (this.productToDownloadedVersionMap[manifestData.ebookCode] && manifestData.data.manifest.shared.productVersion != this.productToDownloadedVersionMap[manifestData.ebookCode]) {
                    let linkedPEs = this.ebookToPEMap[manifestData.ebookCode] ? JSON.parse(JSON.stringify(this.ebookToPEMap[manifestData.ebookCode])) : undefined;
                    let autoUpdateBOOKObject = {
                        previousVersion: this.productToDownloadedVersionMap[manifestData.ebookCode],
                        latestVersion: manifestData.data.manifest.shared.productVersion,
                        uiUpdateShownOnce: false,
                        updateStatus: 'NOT_STARTED',
                        type: 'BOOK',
                        linkedPEs: linkedPEs,
                        onlyPEUpdateNeeded: false,
                        usersWithAccess: undefined,
                        productCode: manifestData.ebookCode,
                        updateDB: true
                    }
                    if (!this.autoUpdateStatus[manifestData.ebookCode]) {
                        this.autoUpdateStatus[manifestData.ebookCode] = autoUpdateBOOKObject;
                    } else {

                        autoUpdateBOOKObject = JSON.parse(JSON.stringify(autoUpdateBOOKObject));

                        if (this.autoUpdateStatus[manifestData.ebookCode].latestVersion != autoUpdateBOOKObject.latestVersion) {
                            this.autoUpdateStatus[manifestData.ebookCode].latestVersion = autoUpdateBOOKObject.latestVersion;
                            this.autoUpdateStatus[manifestData.ebookCode].updateStatus = autoUpdateBOOKObject.updateStatus;
                            this.autoUpdateStatus[manifestData.ebookCode].updateDB = autoUpdateBOOKObject.updateDB;
                        }

                        if (this.autoUpdateStatus[manifestData.ebookCode].onlyPEUpdateNeeded != autoUpdateBOOKObject.onlyPEUpdateNeeded) {
                            this.autoUpdateStatus[manifestData.ebookCode].onlyPEUpdateNeeded = autoUpdateBOOKObject.onlyPEUpdateNeeded;
                            this.autoUpdateStatus[manifestData.ebookCode].updateDB = autoUpdateBOOKObject.updateDB;
                        }

                        if (!this.checkIfArraysAreEqual(this.autoUpdateStatus[manifestData.ebookCode].linkedPEs, autoUpdateBOOKObject.linkedPEs)) {

                            this.autoUpdateStatus[manifestData.ebookCode].linkedPEs = autoUpdateBOOKObject.linkedPEs;
                            this.autoUpdateStatus[manifestData.ebookCode].updateDB = autoUpdateBOOKObject.updateDB;

                        }

                    }
                }

                // log lo manifests.
                if (manifestData.data.loManifest) {
                    // log the latest version for PE and its downloaded version
                    // TODO : Need additional handling for newly added PE and removed PE.
                    Object.keys(manifestData.data.loManifest).forEach(peCode => {
                        if (this.productToDownloadedVersionMap[peCode] && manifestData.data.loManifest[peCode].shared.productVersion != this.productToDownloadedVersionMap[peCode]) {

                            let linkedEBooks = this.PEtoEBookMap[peCode] ? JSON.parse(JSON.stringify(this.PEtoEBookMap[peCode])) : undefined;

                            linkedEBooks = linkedEBooks.filter((bookCode) => { return this.getDownloadedInfoForUser(bookCode) || this.getPausedInfoForUser(bookCode) });

                            let autoUpdatePEObject = {
                                previousVersion: this.productToDownloadedVersionMap[peCode],
                                latestVersion: manifestData.data.loManifest[peCode].shared.productVersion,
                                uiUpdateShownOnce: false,
                                updateStatus: 'NOT_STARTED',
                                type: 'PE',
                                linkedEBooks: linkedEBooks,
                                onlyPEUpdateNeeded: false,
                                usersWithAccess: undefined,
                                productCode: peCode,
                                updateDB: true
                            }

                            if (!this.autoUpdateStatus[peCode]) {
                                this.autoUpdateStatus[peCode] = autoUpdatePEObject;
                            } else {
                                autoUpdatePEObject = JSON.parse(JSON.stringify(autoUpdatePEObject));

                                if (this.autoUpdateStatus[peCode].latestVersion != autoUpdatePEObject.latestVersion) {
                                    this.autoUpdateStatus[peCode].latestVersion = autoUpdatePEObject.latestVersion;
                                    this.autoUpdateStatus[peCode].updateStatus = autoUpdatePEObject.updateStatus;
                                    this.autoUpdateStatus[peCode].updateDB = autoUpdatePEObject.updateDB;
                                }

                                if (!this.checkIfArraysAreEqual(this.autoUpdateStatus[peCode].linkedEBooks, autoUpdatePEObject.linkedEBooks)) {

                                    this.autoUpdateStatus[peCode].linkedEBooks = autoUpdatePEObject.linkedEBooks;
                                    this.autoUpdateStatus[peCode].updateDB = autoUpdatePEObject.updateDB;

                                }
                            }

                            this.PEtoEBookMap[peCode].forEach(ebookCode => {
                                if (this.productToDownloadedVersionMap[ebookCode]) {

                                    let linkedEBooksForPE = this.ebookToPEMap[ebookCode] ? JSON.parse(JSON.stringify(this.ebookToPEMap[ebookCode])) : undefined;
                                    let autoUpdateBOOKObject = {
                                        previousVersion: this.productToDownloadedVersionMap[ebookCode],
                                        latestVersion: latestBookVersionMap[ebookCode],
                                        uiUpdateShownOnce: false,
                                        updateStatus: 'NOT_STARTED',
                                        type: 'BOOK',
                                        linkedPEs: linkedEBooksForPE,
                                        onlyPEUpdateNeeded: true,
                                        usersWithAccess: undefined,
                                        productCode: ebookCode,
                                        updateDB: true
                                    }
                                    if (!this.autoUpdateStatus[ebookCode]) {
                                        this.autoUpdateStatus[ebookCode] = autoUpdateBOOKObject;
                                    } else {
                                        if (this.autoUpdateStatus[ebookCode].latestVersion != autoUpdateBOOKObject.latestVersion) {
                                            this.autoUpdateStatus[ebookCode].latestVersion = autoUpdateBOOKObject.latestVersion;
                                            this.autoUpdateStatus[ebookCode].updateDB = autoUpdateBOOKObject.updateDB;
                                        }

                                        if (!this.checkIfArraysAreEqual(this.autoUpdateStatus[ebookCode].linkedPEs, autoUpdateBOOKObject.linkedPEs)) {

                                            this.autoUpdateStatus[ebookCode].linkedEBooks = autoUpdateBOOKObject.linkedPEs;
                                            this.autoUpdateStatus[ebookCode].updateDB = autoUpdateBOOKObject.updateDB;

                                        }
                                    }

                                }
                            });

                        }
                    });
                }

            }
        });

    }

    generateBookToUsersWithAccessMap(manifestList) {


        for (let manifestData of manifestList) {
            let bookCode = manifestData.ebookCode;

            let pausedData = this.pausedList.get(bookCode);
            let downloadedData = this.downloadedList.get(bookCode);
            let usersWithAccess = [];

            if (pausedData) {
                usersWithAccess = usersWithAccess.concat(pausedData.usersWithAccess);
            }

            if (downloadedData) {
                usersWithAccess = usersWithAccess.concat(downloadedData.usersWithAccess);
            }

            if (this.autoUpdateStatus[bookCode]) {
                if (this.autoUpdateStatus[bookCode].usersWithAccess) {
                    usersWithAccess = usersWithAccess.concat(this.autoUpdateStatus[bookCode].usersWithAccess);
                }
                usersWithAccess = usersWithAccess.filter(function (item, pos, self) {
                    return self.indexOf(item) == pos;
                })
                if (!this.checkIfArraysAreEqual(this.autoUpdateStatus[bookCode].usersWithAccess, usersWithAccess)) {

                    this.autoUpdateStatus[bookCode].usersWithAccess = usersWithAccess;
                    this.autoUpdateStatus[bookCode].updateDB = true;

                }
            }

            if (manifestData.data.loManifest) {
                for (let peCode in manifestData.data.loManifest) {
                    if (this.autoUpdateStatus[peCode]) {
                        if (this.autoUpdateStatus[peCode].usersWithAccess) {
                            usersWithAccess = usersWithAccess.concat(this.autoUpdateStatus[peCode].usersWithAccess);
                        }
                        usersWithAccess = usersWithAccess.filter(function (item, pos, self) {
                            return self.indexOf(item) == pos;
                        })
                        if (!this.checkIfArraysAreEqual(this.autoUpdateStatus[peCode].usersWithAccess, usersWithAccess)) {

                            this.autoUpdateStatus[peCode].usersWithAccess = usersWithAccess;
                            this.autoUpdateStatus[peCode].updateDB = true;
        
                        }
                    }
                }
            }

        }

        // remove data from auto-update object for downloaded objects not belonging to current user.
        // case : user 1 downloaded book, user 2 also has access to same book but has not downloaded it. when the book is updated, it is added to auto-update.
        // this object drives the UI for available offline.
        this.removeAutoUpdateStatusOfBooksNotDownloadedByCurrentUser();
        
    }

    removeAutoUpdateStatusOfBooksNotDownloadedByCurrentUser() {
        let userData = this.userdataService.getLoggedInUser();

        // remove data from auto-update object for downloaded objects not belonging to current user.
        // case : user 1 downloaded book, user 2 also has access to same book but has not downloaded it. when the book is updated, it is added to auto-update.
        // this object drives the UI for available offline.

        Object.keys(this.autoUpdateStatus).forEach((productCode) => {
            let updateObject = this.autoUpdateStatus[productCode];
            if (updateObject) {
                let usersWithAccessList = updateObject.usersWithAccess;
                if (usersWithAccessList.indexOf(userData.uid) == -1) {
                    delete this.autoUpdateStatus[productCode];
                }
            }
        })

    }

    async updateDownloadListsAndDBWithAutoUpdateStatus(manifestList) {

        for (let manifestData of manifestList) {
            let bookCode = manifestData.ebookCode;

            // check and update lists and DB for book.
            if (this.autoUpdateStatus[bookCode]) {
                let data = this.autoUpdateStatus[bookCode];

                let pausedData = this.pausedList.get(bookCode);
                if (pausedData) {
                    pausedData.autoUpdateStatus = data;
                    this.pausedList.set(bookCode, pausedData);
                }

                let downloadedData = this.downloadedList.get(bookCode);
                if (downloadedData) {
                    downloadedData.autoUpdateStatus = data;
                    this.downloadedList.set(bookCode, downloadedData);
                }
                if (data.updateDB) {
                    delete data.updateDB;
                    window.DLS_IPCCallers && await DLS_IPCCallers.DB_ADD_AUTOUPDATE_DATA({ productCode: bookCode, autoUpdateStatus: data });
                }
            }

            // check and update lists and DB for linked PEs.
            if (manifestData.data.loManifest) {

                // log the latest version for PE and its downloaded version
                // TODO : Need additional handling for newly added PE and removed PE.
                for (let peCode in manifestData.data.loManifest) {

                    if (this.autoUpdateStatus[peCode]) {
                        let data = this.autoUpdateStatus[peCode];

                        let pePausedData = this.pePausedList.get(peCode);
                        if (pePausedData) {
                            pePausedData.autoUpdateStatus = data;
                            this.pePausedList.set(peCode, pePausedData);
                        }

                        let peDownloadedData = this.peDownloadedList.get(peCode);
                        if (peDownloadedData) {
                            peDownloadedData.autoUpdateStatus = data;
                            this.peDownloadedList.set(peCode, peDownloadedData);
                        }

                        if(data.updateDB) {
                            delete data.updateDB;
                            window.DLS_IPCCallers && await DLS_IPCCallers.DB_PE_ADD_AUTOUPDATE_DATA({ productCode: peCode, autoUpdateStatus: data });
                        }
                    }
                }

            }

        }

    }

    createAutoUpdateQueue(manifestList) {

        let autoUpdateQueue = [];
        let userData = this.userdataService.getLoggedInUser();


        for (let manifestData of manifestList) {
            let bookCode = manifestData.ebookCode;
            if (this.autoUpdateStatus[bookCode]) {
                autoUpdateQueue.push(JSON.parse(JSON.stringify(this.autoUpdateStatus[bookCode])));
            }
            if (manifestData.data.loManifest) {
                for (let peCode in manifestData.data.loManifest) {
                    if (this.autoUpdateStatus[peCode]) {
                        autoUpdateQueue.push(JSON.parse(JSON.stringify(this.autoUpdateStatus[peCode])));

                    }
                }
            }
        }


        let expiredEntitlements = this.activateComponentService.getExpiredEntitlementsForUser();

        autoUpdateQueue = autoUpdateQueue.filter((value, index, autoUpdateQueue) => autoUpdateQueue.findIndex(newValue => (newValue.productCode === value.productCode)) === index);

        autoUpdateQueue = autoUpdateQueue.filter((autoUpdateObject) => {
            return autoUpdateObject.usersWithAccess.indexOf(userData.uid) > -1;
        });

        autoUpdateQueue = autoUpdateQueue.filter((autoUpdateObject) => {
            return !autoUpdateObject.onlyPEUpdateNeeded;
        });

        autoUpdateQueue = autoUpdateQueue.filter((autoUpdateObject) => {
            return autoUpdateObject.updateStatus != 'COMPLETE';
        });

        autoUpdateQueue = autoUpdateQueue.filter((autoUpdateObject) => {
            return expiredEntitlements.indexOf(autoUpdateObject.productCode) == -1;
        });

        this.autoUpdateQueue = this.autoUpdateQueue.concat(autoUpdateQueue);

        if (this.autoUpdateQueue.length) {
            this.startAutoUpdating(this.autoUpdateQueue[0]);
        }

        this.syncUserData(autoUpdateQueue);

    }

    async syncUserData(autoUpdateQueue) {

        let isOnline = await this.networkService.isOnline(true);
        if (!isOnline) return;

        let userData = this.userdataService.getLoggedInUser();

        for (let updateObject of autoUpdateQueue) {
            if (updateObject.type == 'BOOK') {

                let spaceId = this.bookIDtoSpaceIDmap.get(updateObject.productCode);

                if (!spaceId) spaceId = this.bookIDtoSpaceIDmap.get('privateSpace');
                if (!spaceId) spaceId = this.bookIDtoSpaceIDmap.get('firstSpace');

                await this.desktopEBookVMService.syncUserData(userData.uid, updateObject.productCode, spaceId);
                // delete previous resources.
                await this.helperService.delUserSpecificBookData(updateObject.productCode, { uid: userData.uid });

            }
        }

    }

    checkIfArraysAreEqual(array1, array2) {
        if (!array1 && !array2) return true;
        if (!array1) return false;
        if (!array2) return false;
        if (array1.length != array2.length) return false;

        for (let i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) return false;
        }
        return true;

    }


    /**
     * PPlus Handling
     */

     isPPlusProductDownloaded(pplusProduct, space) {

        if(!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);

        let allDownloaded = false;

        for (let ebook of list_of_downloadable_books) {
            if(!this.getDownloadedInfoForUser(ebook['dls-product'].code)) {
                allDownloaded = false;
                break;
            } else {
                allDownloaded = true;
            }
        }

        return allDownloaded;

    }

    isExpiredPPlusProductDownloaded(pplusProduct, space) {

        if(!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, false, false, false, true);

        let allDownloaded = false;

        for (let ebook of list_of_downloadable_books) {
            if(!this.getDownloadedInfoForUser(ebook['dls-product'].code)) {
                allDownloaded = false;
                break;
            } else {
                allDownloaded = true;
            }
        }

        return allDownloaded;

    }

    getPPlusDownloadingInfoForUser(pplusProduct, space) {
        if(!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloading_books = this.getPPlusDownloadingBooksList(pplusProduct, space);

        let downloadingInfo;

        for (let ebook of list_of_downloading_books) {
            if(!downloadingInfo) {
                downloadingInfo = this.getDownloadingInfoForUser(ebook['dls-product'].code);
            } else {
                downloadingInfo.totalProgress += this.getDownloadingInfoForUser(ebook['dls-product'].code).totalProgress;
                downloadingInfo.wait = downloadingInfo.wait || this.getDownloadingInfoForUser(ebook['dls-product'].code).wait;
            }
        }

        return downloadingInfo;

    }

    getPPlusPausedInfoForUser(pplusProduct, space) {
        if(!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_paused_books = this.getPPlusPausedBooksList(pplusProduct, space);

        let pausedInfo;

        for (let ebook of list_of_paused_books) {
            if(!pausedInfo) {
                pausedInfo = this.getPausedInfoForUser(ebook['dls-product'].code);
            } else {
                pausedInfo.totalProgress += this.getPausedInfoForUser(ebook['dls-product'].code).totalProgress;
                pausedInfo.wait = pausedInfo.wait || this.getPausedInfoForUser(ebook['dls-product'].code).wait;
            }
        }

        return pausedInfo;

    }

    getPPlusDownloadedInfoForUser(pplusProduct, space) {
        if(!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloaded_books = this.getPPlusDownloadedBooksList(pplusProduct, space);

        let downloadInfo;

        for (let ebook of list_of_downloaded_books) {
            if(!downloadInfo) {
                downloadInfo = this.getDownloadedInfoForUser(ebook['dls-product'].code);
            } else {
                downloadInfo.totalPackageSize += this.getDownloadedInfoForUser(ebook['dls-product'].code).totalPackageSize;
            }
        }

        return downloadInfo;
    }

    getPPlusManifestSize(pplusProduct, space) {

        let zippedBytes = 0;
        let unzippedBytes = 0;
        if (!pplusProduct || !pplusProduct.pplus) {
            return {
                "fileSize": undefined,
                "fileSizeUnit": undefined,
                "unZippedFileSize": undefined,
                "unZippedFileSizeUnit": undefined
            }
        }

        // get list of all downloadable books
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);
        let bookWithNoManifestFound = false;
        for (let ebook of list_of_downloadable_books) {
            if (ebook.manifest) {
                zippedBytes += this.sizeToBytes(ebook.manifest.fileSize, ebook.manifest.fileSizeUnit);
                unzippedBytes += this.sizeToBytes(ebook.manifest.unZippedFileSize, ebook.manifest.unZippedFileSizeUnit);
            } else if(!ebook.manifest) {
                bookWithNoManifestFound = true;
            }
        }

        let zippedSize = this.bytesToSize(zippedBytes);
        let unzippedSize = this.bytesToSize(unzippedBytes);

        if (!bookWithNoManifestFound && zippedSize.size) {
            return {
                "fileSize": zippedSize.size,
                "fileSizeUnit": zippedSize.unit,
                "unZippedFileSize": unzippedSize.size,
                "unZippedFileSizeUnit": unzippedSize.unit
            }
        } else {
            return {
                "fileSize": undefined,
                "fileSizeUnit": undefined,
                "unZippedFileSize": undefined,
                "unZippedFileSizeUnit": undefined
            }
        }

    }

    pausePPlusDownload(pplusProduct, space) {
        if (!pplusProduct || !pplusProduct.pplus) return;

        this.setPPlusBundleUserActionStateMap(pplusProduct.bundleCode, this.EVENTS.PAUSE);

        // get list of all downloadable books
        let list_of_downloadable_books = this.getPPlusDownloadingBooksList(pplusProduct, space);

        if (list_of_downloadable_books.length == 0) {
            list_of_downloadable_books = this.getPPlusPausedBooksList(pplusProduct, space);
        }

        for (let ebook of list_of_downloadable_books) {
            this.initiatePauseDownloading(ebook['dls-product'].code)
        }

    }

    sizeToBytes(bytes, unit){
        if (bytes == 0) return 0;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        return  bytes*Math.pow(1024,(sizes.indexOf(unit)));
    }

    bytesToSize(bytes) {
        let size = 0;
        let unit = 'Bytes';
        if (bytes >= 1073741824) {
            unit = "GB";
            size = Math.round((bytes / 1073741824) * 100) / 100;
        } else if (bytes >= 1048576) {
            unit = "MB";
            size = Math.round((bytes / 1048576) * 100) / 100;
        } else if (bytes >= 1024) {
            unit = "KB";
            size = Math.round((bytes / 1024) * 100) / 100;
        } else {
            size = Math.round((bytes) * 100) / 100;
        }
        return { size, unit }
    }

    getSeperatedPPlusBooks(pplusProduct, space) {
        if (!pplusProduct || !pplusProduct.pplus) return;

        // get list of all downloadable books
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, false, false, false, true);

        let downloadedBooks = list_of_downloadable_books.filter((book) => { return this.getDownloadedInfoForUser(book['dls-product'].code) });
        let pausedBooks = list_of_downloadable_books.filter((book) => { return this.getPausedInfoForUser(book['dls-product'].code) });
        let downloadingBooks = list_of_downloadable_books.filter((book) => { return this.getDownloadingInfoForUser(book['dls-product'].code) });

        return {
            downloadedBooks,
            pausedBooks,
            downloadingBooks
        }


    }

    getDownloadableBooksList(pplusProduct, space, removeDownloaded = false, removeDownloading = false, removePaused = false, keepExpired = false) {

        // get list of all downloadable books
        let list_of_downloadable_books = pplusProduct && pplusProduct.pplus && pplusProduct.pplus.products;

        // filter out coming soon books, hidden books are already filtered out
        list_of_downloadable_books = list_of_downloadable_books.filter((book) => { return this.helperService.isEbookVisible(book, space, false) });

        // filter out expired books
        if(!keepExpired) {
            list_of_downloadable_books = list_of_downloadable_books.filter((book) => { return !book.isExpired });
        }

        // filter out downloaded books
        if (removeDownloaded) {
            list_of_downloadable_books = list_of_downloadable_books.filter((book => { return !this.getDownloadedInfoForUser(book['dls-product'].code) }));
        }

        // filter out currently downloading books
        if (removeDownloading) {
            list_of_downloadable_books = list_of_downloadable_books.filter((book => { return !this.getDownloadingInfoForUser(book['dls-product'].code) }));
        }

        // filter out currently paused books
        if (removePaused) {
            list_of_downloadable_books = list_of_downloadable_books.filter((book => { return !this.getPausedInfoForUser(book['dls-product'].code) }));
        }

        return list_of_downloadable_books;
    }

    getPPlusDownloadedBooksList(pplusProduct, space) {
        let books_list = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);
        books_list = books_list.filter((book => { return this.getDownloadedInfoForUser(book['dls-product'].code) }));
        return books_list;
    }

    getPPlusDownloadingBooksList(pplusProduct, space) {
        let books_list = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);
        books_list = books_list.filter((book => { return this.getDownloadingInfoForUser(book['dls-product'].code) }));
        return books_list;
    }

    getPPlusPausedBooksList(pplusProduct, space) {
        let books_list = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);
        books_list = books_list.filter((book => { return this.getPausedInfoForUser(book['dls-product'].code) }));
        return books_list;
    }

    isPPlusDownloadPossible(pplusProduct, space) {
        let downloadable_book_list = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);
        let downloading_book_list = this.getPPlusDownloadingBooksList(pplusProduct, space);
        let paused_book_list = this.getPPlusPausedBooksList(pplusProduct, space);

        // if there is no book currently being downloaded but there are books that can be downloaded, return true
        if ((downloading_book_list.length == 0 && paused_book_list.length == 0) && downloadable_book_list.length > 0) {
            return true;
        } else {
            return false;
        }

    }

    getPPlusProgress(pplusProduct, space) {
        let downloaded_books = this.getPPlusDownloadedBooksList(pplusProduct, space);
        let downloading_books = this.getPPlusDownloadingBooksList(pplusProduct, space);
        let paused_books = this.getPPlusPausedBooksList(pplusProduct, space);

        let total_books_list = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);

        let progress = 0;

        for (let ebook of downloading_books) {
            let bookData = this.getDownloadingInfoForUser(ebook['dls-product'].code);
            if (bookData) {
                progress += bookData.totalProgress;
            }
        }

        for (let ebook of paused_books) {
            let bookData = this.getPausedInfoForUser(ebook['dls-product'].code);
            if (bookData) {
                progress += bookData.totalProgress;
            }
        }

        progress = progress + (downloaded_books.length * 100);

        return progress / total_books_list.length;
    }

    getLastPPlusEvent(pplusProduct, space) {
        let downloadable_books = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);
        let first_downloadable_book = downloadable_books[0];
        if(!first_downloadable_book) return undefined;
        let lastEvent = this.getLastEvent(first_downloadable_book['dls-product'].code);
        return lastEvent;
    }

    getPPlusPausedButtonState(pplusProduct, space) {
        let downloadable_books = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);
        let first_downloadable_book = downloadable_books[0];

        if(!first_downloadable_book) return false;

        let lastEvent = this.getLastEvent(first_downloadable_book['dls-product'].code);

        if (lastEvent == 'START') {
            return true;
        } else {
            if (lastEvent == undefined && this.getPPlusDownloadingInfoForUser(pplusProduct, space) && !this.getPPlusDownloadedInfoForUser(pplusProduct, space) && !this.getPPlusPausedInfoForUser(pplusProduct, space)) {
                return true;
            }
        }
        return false;
    }

    getPPlusResumeButtonState(pplusProduct, space) {
        let downloadable_books = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);
        let first_downloadable_book = downloadable_books[0];
        if(!first_downloadable_book) return false;

        let lastEvent = this.getLastEvent(first_downloadable_book['dls-product'].code);

        if (lastEvent == 'PAUSE') {
            return true;
        } else {
            if (lastEvent == undefined && (this.getPPlusPausedInfoForUser(pplusProduct, space) || this.getPPlusDownloadedInfoForUser(pplusProduct, space)) && !this.getPPlusDownloadingInfoForUser(pplusProduct, space) ) {
                return true;
            }
        }
        return false;
    }

    addpPlusBundleToMap(bundleCode, pplusData, spaceKey){
        this.pplusBundleCodeToPPlusProductMap[bundleCode] = {product: pplusData, space: spaceKey};
        this.generatePPlusDownloadMap(bundleCode, pplusData, spaceKey);

    }

    getpPlusData(bundleCode){
        return this.pplusBundleCodeToPPlusProductMap[bundleCode];
    }

    addpPlusBook(bundleCode, bookCode){
        this.pPlusBookCodeToBundleCodeMap[bookCode] = bundleCode;

        if(!this.pplusBundleCodetoBookCodeMap[bundleCode]) {
            this.pplusBundleCodetoBookCodeMap[bundleCode] = [];
        }
        this.pplusBundleCodetoBookCodeMap[bundleCode].push(bookCode);

    }

    getpPlusCode(bookCode){
        return this.pPlusBookCodeToBundleCodeMap[bookCode];
    }

    generatePPlusDownloadMap(bundleCode, pplusProduct, space) {

        let downloadable_books = this.getDownloadableBooksList(pplusProduct, space, false, false, false, false);

        if (!this.pplusBundleBookDownloadStateMap[bundleCode]) {
            this.pplusBundleBookDownloadStateMap[bundleCode] = {};
        }

        downloadable_books.forEach(book => {
            this.pplusBundleBookDownloadStateMap[bundleCode][book['dls-product'].code] = undefined;
        });

        if (Object.keys(this.pplusBundleBookDownloadStateMap[bundleCode]).length == 0) {
            delete this.pplusBundleBookDownloadStateMap[bundleCode];
        }

        this.updatePPlusDownloadMap();
    }

    updatePPlusDownloadMap() {

        Object.keys(this.pplusBundleBookDownloadStateMap).forEach(bundleCode => {
            Object.keys(this.pplusBundleBookDownloadStateMap[bundleCode]).forEach((productCode) => {
                this.pplusBundleBookDownloadStateMap[bundleCode][productCode] = this.ebookDownloadStateMap[productCode];
            })
        });

        Object.keys(this.pplusBundleBookDownloadStateMap).forEach(bundleCode => {

            if (!this.pplusBundleDownloadStateMap[bundleCode]) {
                this.pplusBundleDownloadStateMap[bundleCode] = undefined;
            }

            let stateArray = [];

            Object.keys(this.pplusBundleBookDownloadStateMap[bundleCode]).forEach((productCode) => {
                stateArray.push(this.pplusBundleBookDownloadStateMap[bundleCode][productCode]);
            })

            let undefinedCount = 0, finishedCount = 0, removedCount = 0, startCount = 0, pausedCount = 0;

            stateArray.forEach(state => {
                if (state == undefined) undefinedCount++;
                else if (state == this.EVENTS.START) startCount++;
                else if (state == this.EVENTS.FINISH) finishedCount++;
                else if (state == this.EVENTS.REMOVE) removedCount++;
                else if (state == this.EVENTS.PAUSE) pausedCount++;
            });

            if (undefinedCount == stateArray.length) this.pplusBundleDownloadStateMap[bundleCode] = undefined;
            else if (finishedCount == stateArray.length) this.pplusBundleDownloadStateMap[bundleCode] = this.EVENTS.FINISH;
            else if (removedCount == stateArray.length) this.pplusBundleDownloadStateMap[bundleCode] = this.EVENTS.REMOVE;
            else if (removedCount + undefinedCount == stateArray.length) this.pplusBundleDownloadStateMap[bundleCode] = undefined;
            else if (startCount) this.pplusBundleDownloadStateMap[bundleCode] = this.EVENTS.START;
            else if (pausedCount) this.pplusBundleDownloadStateMap[bundleCode] = this.EVENTS.PAUSE;
            else if (finishedCount) this.pplusBundleDownloadStateMap[bundleCode] = this.pplusBundleUserActionStateMap[bundleCode] ? this.pplusBundleUserActionStateMap[bundleCode] : this.EVENTS.PAUSE;
            else this.pplusBundleDownloadStateMap[bundleCode] = undefined;


        });

    }

    setPPlusBundleUserActionStateMap(bundleCode, state) {
        this.pplusBundleUserActionStateMap[bundleCode] = state;
    }

    resetPPlusDownloadState() {
        this.pplusBundleDownloadStateMap = {};
        this.pplusBundleBookDownloadStateMap = {};
    }

    resetPPlusBundleMaps() {
        this.pplusBundleCodeToPPlusProductMap = {};
        this.pPlusBookCodeToBundleCodeMap = {};
        this.pplusBundleCodetoBookCodeMap = {};
        this.pplusBundleUserActionStateMap = {};
    }

    isPPlusDownloadQueued(pplusProduct, space) {
        let list_of_downloadable_books = this.getDownloadableBooksList(pplusProduct, space, true, false, false, false);
        let isQueued = false;
        if (list_of_downloadable_books.length) {
            isQueued = this.isBookDownloadQueued(list_of_downloadable_books[0]['dls-product'].code);
        }
        return isQueued;
    }

}

